<template>
  <div class="app flex-row align-items-center Back">
    <div class="container">
      <b-row class="justify-content-center">
        <div class="col">
          <!-- <div style="height: 20vh"></div> -->
          <div>
            <!-- <b-jumbotron>
              <template v-slot:header
                ><span class="text-secondary h1">گزارش خطا</span></template>

              <template v-slot:lead>
                <h2 class="text-info">
                  لطفا هرگونه خطایی که در سیستم مشاهده کرده‌اید را در فرم زیر
                  ثبت بفرمایید.
                </h2>
              </template> -->
            <h1 class="text-secondary my-3">گزارش خطا</h1>
            <h3 class="text-info my-3">
              لطفا هرگونه خطایی که در سیستم مشاهده کرده‌اید را در فرم زیر ثبت
              بفرمایید.
            </h3>
            <h5 class="text-info my-3">
              مشکلات گزارش شده توسط شما توسط همکاران ما بررسی و در اسرع وقت
              برطرف خواهندشد.
            </h5>

            <hr />

            <b-form-group label="عنوان خطا">
              <b-form-input trim v-model="bug.subject"> </b-form-input>
            </b-form-group>
            <b-form-group label="نوع خطا">
              <b-select :options="bugOptions" trim v-model="bug.supportType">
              </b-select>
            </b-form-group>
            <b-form-group label="توضیحات خطا">
              <b-form-textarea trim rows="6" v-model="bug.description">
              </b-form-textarea>
            </b-form-group>

            <b-button variant="success" :disabled="busy" @click="submit()"
              >ثبت خطا</b-button
            >
            <!-- </b-jumbotron> -->
          </div>
        </div>
        <!-- <p style="font-size:100px" class="text-primary">404 </p> -->

        <!-- <div class="col">
          <img src="../assets/images/403-4.gif" class="container-fluid" />
        </div> -->

        <!-- 
        <b-col >
           <div class="clearfix">
            <h1 class="float-left display-3 mr-4">
            404
            </h1>
            <h4 class="pt-3">برگه یافت نشد</h4>
         
            <a href="/">
              <p class="text-muted">بازگشت به خانه</p>
            </a>
          </div>
            
        </b-col>
        <b-col class="6">
          
        </b-col>
       -->
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page404",
  components: {},
  data() {
    return {
      bug: {},
      bugOptions: [
        { value: "فنی", text: "فنی" },
        { value: "علمی", text: "علمی" },
      ],

      busy: false,
    };
  },

  methods: {
    submit() {
      this.busy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/profile/bugReport",
          {
            subject: this.bug.subject,
            description: this.bug.description,
            supportType: this.bug.supportType,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.busy = false;
            this.bug.subject = "";
            this.bug.description = "";
            this.bug.supportType = "";
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
  },
};
</script>
<style>
.Back {
  background-color: #ffffff;
  /* background-image: url("../assets/images/resBack.png");

  background-size: cover; */
}
.jumbotron {
  background-color: #ffffff;
}
/* .responsive {
  width: 100%;
  max-width: 800px;
  height: auto;
} */
</style>
